import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

export async function getAllOrderDocumentTypes() {
  const apiPath = '/documentType'
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  const httpClient = new HttpClient(headers)
  return httpClient.documentInstance().get(apiPath)
}
